"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const EventKey_1 = __importDefault(require("./EventKey"));
/**
 * A hook that binds to global action key events (example: Enter or Space) and calls the provided handler once any of the specified keys have been pressed
 * @param { Function } actionKeyHandler The handler to be called when Enter or Space has been pressed
 * @param fireEvents specify the events
 * @param windowContext
 * @returns { void }
 */
const useGlobalActionKeyHandler = ({ actionKeyHandler, windowContext, fireEvents = [EventKey_1.default.Enter, EventKey_1.default.Space], }) => {
    const handleKeyPress = (event) => {
        if (fireEvents.includes(event.key)) {
            // eslint-disable-next-line no-unused-expressions
            actionKeyHandler && actionKeyHandler();
        }
    };
    (0, react_1.useEffect)(() => {
        (windowContext || window).document.addEventListener('keydown', handleKeyPress);
        return () => {
            (windowContext || window).document.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleKeyPress]);
};
exports.default = useGlobalActionKeyHandler;
